import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '../api/client';
import { useCurrentUser } from './CurrentUserContext';

const ContactsContext = createContext(null);

export const useContacts = () => {
  const context = useContext(ContactsContext);
  if (!context) throw new Error('useContacts must be used within a ContactsProvider');
  return context;
};

export const ContactsProvider = ({ children }) => {
  const { currentUser, activeWorkspaceId } = useCurrentUser();
  const [contacts, setContacts] = useState([]);

  const refresh = useCallback(() => {
    api('/api/contacts')
      .then(res => res.json())
      .then(data => { if (Array.isArray(data.contacts)) setContacts(data.contacts); })
      .catch(err => console.error('Failed to load contacts:', err));
  }, []);

  useEffect(() => {
    if (!currentUser?.id) return;
    refresh();
  }, [currentUser?.id, activeWorkspaceId, refresh]);

  useEffect(() => {
    window.addEventListener('aidey:contactsUpdated', refresh);
    return () => window.removeEventListener('aidey:contactsUpdated', refresh);
  }, [refresh]);

  return (
    <ContactsContext.Provider value={{ contacts, setContacts, refresh }}>
      {children}
    </ContactsContext.Provider>
  );
};
